import {
  getUserOrder,
  findClientRetailOrderByParam,
  cancelOrder,
  deleteOrder,
  againBuy,
  confirmOrder,
  getTrackingDataBySubOrderSn,
  toExchangeCardVoucher,
  exchangeCardVoucher,
  getAfterSaleList,
  deleteAfterSale,
  getAfterSaleInfo,
  getNegotiationHistory,
  commitLogistics,
  getDistributionPlan,
  getAfterLogistics,
  cancelAfterSale,
  getOptionalAfterOrder,
  addAfterSale,
  updateDistributionPlanPlanDeliveredAt,
  updateDistributionPlanAddress,
  paymentPage,
  paySuccessd,
  jsticket,
  getPeriodOptionalAfterOrder,
  getContactor,
  queryCardVoucherUserByIdNoUserId,
  presentCardVoucherUser,
  getTrackingDataByTrackingNo
} from "@/api/order";
const state = {
  getUserOrder: {
    address: {},
    retailSubOrderList: [
      {
        orderDetailList: []
      }
    ],
    status: 10
  },
  findClientRetailOrderByParam: {
    rows: [
      {
        retailSubOrderList: []
      }
    ]
  },
  searchOrderKeys: [],
  getTrackingDataBySubOrderSn: {
    trackingDataList: [],
    companyName: ""
  },
  toExchangeCardVoucher: {
    storeName: "",
    address: {}
  },
  getAfterSaleList: {
    rows: []
  },
  getAfterSaleInfo: {},
  getNegotiationHistory: [],
  commitLogistics: {},
  getDistributionPlan: {},
  getAfterLogistics: [],
  getOptionalAfterOrder: [],
  getPeriodOptionalAfterOrder: {},
  getContactor: {},
  queryCardVoucherUserByIdNoUserId: {},
  getTrackingDataByTrackingNo: {}
};

const mutations = {
  SET_GETUSERORDER(state, data) {
    state.getUserOrder = data;
  },
  SET_FINDCLIENTRETAILORDERBYPARAM(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.findClientRetailOrderByParam = data;
    } else {
      const data1 = state.findClientRetailOrderByParam.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.findClientRetailOrderByParam = data;
    }
    // state.findClientRetailOrderByParam = data;
  },
  SET_AFTERSALE_LIST(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.getAfterSaleList = data;
    } else {
      const data1 = state.getAfterSaleList.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.getAfterSaleList = data;
    }
  },
  SET_SEARCH_ORDER_KEYS: function(state, datas) {
    state.searchOrderKeys = datas;
  },
  SET_TRACKINF_DATA: function(state, datas) {
    state.getTrackingDataBySubOrderSn = datas;
  },
  SET_TO_EXCHANGE_CARD_VOUCHER: function(state, keys) {
    state.toExchangeCardVoucher = keys;
  },
  SET_GET_AFTERSALEINFO: function(state, datas) {
    state.getAfterSaleInfo = datas;
  },
  SET_GET_NEGOTIATION_HISTORY: function(state, datas) {
    state.getNegotiationHistory = datas;
  },
  SET_GET_DISTRIBUTIONPLAN: function(state, datas) {
    state.getDistributionPlan = datas;
  },
  SET_GET_AFTERLOGISTICS: function(state, datas) {
    state.getAfterLogistics = datas;
  },
  SET_GET_PERIOD_OPTIONAL_AFTERORDER: function(state, datas) {
    state.getPeriodOptionalAfterOrder = datas;
  },
  SET_GET_CONTANCTOR: function(state, datas) {
    state.getContactor = datas;
  },
  SET_QUERY_CARD_VOUCHER_UESER_BY_ID_NO_USERID: function(state, datas) {
    state.queryCardVoucherUserByIdNoUserId = datas;
  },
  SET_GET_TRACKING_DATA_BY_TRACKING_NO: function(state, datas) {
    state.getTrackingDataByTrackingNo = datas;
  },
  SET_GET_OPTIONAL_AFTER_ORDER: function(state, datas) {
    datas.forEach(item => {
      item.isAllSelect = false;
      item.orderDetailList.forEach(i => {
        i.isSelect = false;
      });
    });
    state.getOptionalAfterOrder = datas;
  },
  SET_CANCEL_ORDER: function() {},
  SET_DELETE_ORDER: function() {},
  SET_BUYAGAIN_ORDER: function() {},
  SET_CONFIRM_ORDER: function() {},
  SET_EXCHANGE_CARD_VOUCHER: function() {},
  SET_DELETE_AFTERSALE: function() {},
  SET_COMM_LOGIST: function() {},
  SET_CANCEL_AFTER_SALE: function() {},
  SET_ADD_AFTER_SALE: function() {},
  SET_MODIFY_PLAN: function() {},
  SET_MODIFY_PLAN_ADDRESS: function() {},
  SET_PAYMENT_PAGE: function() {},
  SET_PAYMENT_SUCC: function() {},
  SET_JSTICKET: function() {}
};

const actions = {
  // 订单详情
  async getUserOrder({ commit }, { params }) {
    const response = await getUserOrder(params);
    if (response.code === 1) {
      commit("SET_GETUSERORDER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 订单列表
  async findClientRetailOrderByParam({ commit }, { params }) {
    const response = await findClientRetailOrderByParam(params);
    if (response.code === 1) {
      commit("SET_FINDCLIENTRETAILORDERBYPARAM", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 历史搜索
  async setSearchOrderKeys({ commit }, { keywords }) {
    // console.log(keywords, "keywords");
    let str = localStorage.SEARCH_ORDER_KEYS;
    if (str) {
      const keys = JSON.parse(str);
      const filters = keys.filter(key => key !== keywords);
      const newKeys = [keywords, ...filters];
      newKeys.splice(30);
      localStorage.SEARCH_ORDER_KEYS = JSON.stringify(newKeys);
      commit("SET_SEARCH_ORDER_KEYS", newKeys);
    } else {
      const keys = [keywords];
      localStorage.SEARCH_ORDER_KEYS = JSON.stringify(keys);
      commit("SET_SEARCH_ORDER_KEYS", keys);
    }
  },
  // 历史搜索初始化
  async initSearchOrderKeys({ commit }, { keys, callback }) {
    commit("SET_SEARCH_ORDER_KEYS", keys);
    callback();
  },
  // 取消订单
  async cancelOrder({ commit }, { params }) {
    const response = await cancelOrder(params);
    if (response.code === 1) {
      commit("SET_CANCEL_ORDER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 申请退款信息
  async getContactor({ commit }, { params }) {
    const response = await getContactor(params);
    if (response.code === 1) {
      commit("SET_GET_CONTANCTOR", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 删除订单
  async deleteOrder({ commit }, { params }) {
    const response = await deleteOrder(params);
    if (response.code === 1) {
      commit("SET_DELETE_ORDER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 再次购买
  async againBuy({ commit }, { params }) {
    const response = await againBuy(params);
    if (response.code === 1) {
      commit("SET_BUYAGAIN_ORDER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 确认收货
  async confirmOrder({ commit }, { params }) {
    const response = await confirmOrder(params);
    if (response.code === 1) {
      commit("SET_CONFIRM_ORDER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 查看物流
  async getTrackingDataBySubOrderSn({ commit }, { params }) {
    const response = await getTrackingDataBySubOrderSn(params);
    if (response.code === 1) {
      commit("SET_TRACKINF_DATA", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 确认订单兑换鲜奶页面
  async toExchangeCardVoucher({ commit }, { params }) {
    const response = await toExchangeCardVoucher(params);
    if (response.code === 1) {
      commit("SET_TO_EXCHANGE_CARD_VOUCHER", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 兑换鲜奶
  async exchangeCardVoucher({ commit }, { params }) {
    const response = await exchangeCardVoucher(params);
    if (response.code === 1) {
      commit("SET_EXCHANGE_CARD_VOUCHER", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 售后列表
  async getAfterSaleList({ commit }, { params }) {
    const response = await getAfterSaleList(params);
    if (response.code === 1) {
      commit("SET_AFTERSALE_LIST", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 售后列表
  async getAfterSaleInfo({ commit }, { params }) {
    const response = await getAfterSaleInfo(params);
    if (response.code === 1) {
      commit("SET_GET_AFTERSALEINFO", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 删除售后
  async deleteAfterSale({ commit }, { params }) {
    const response = await deleteAfterSale(params);
    if (response.code === 1) {
      commit("SET_DELETE_AFTERSALE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 协商历史
  async getNegotiationHistory({ commit }, { params }) {
    const response = await getNegotiationHistory(params);
    if (response.code === 1) {
      commit("SET_GET_NEGOTIATION_HISTORY", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 填写物流
  async commitLogistics({ commit }, { params }) {
    const response = await commitLogistics(params);
    if (response.code === 1) {
      commit("SET_COMM_LOGIST", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 物流列表
  async getAfterLogistics({ commit }, { params }) {
    const response = await getAfterLogistics(params);
    if (response.code === 1) {
      commit("SET_GET_AFTERLOGISTICS", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 撤销售后
  async cancelAfterSale({ commit }, { params }) {
    const response = await cancelAfterSale(params);
    if (response.code === 1) {
      commit("SET_CANCEL_AFTER_SALE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 配送计划
  async getDistributionPlan({ commit }, { params }) {
    const response = await getDistributionPlan(params);
    if (response.code === 1) {
      commit("SET_GET_DISTRIBUTIONPLAN", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 修改配送计划
  async updateDistributionPlanPlanDeliveredAt({ commit }, { params }) {
    const response = await updateDistributionPlanPlanDeliveredAt(params);
    if (response.code === 1) {
      commit("SET_MODIFY_PLAN", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 修改配送计划地址
  async updateDistributionPlanAddress({ commit }, { params }) {
    const response = await updateDistributionPlanAddress(params);
    if (response.code === 1) {
      commit("SET_MODIFY_PLAN_ADDRESS", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject(response);
  },
  // 获取订单可配送包裹
  async getOptionalAfterOrder({ commit }, { params }) {
    const response = await getOptionalAfterOrder(params);
    if (response.code === 1) {
      commit("SET_GET_OPTIONAL_AFTER_ORDER", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 获取订单可售后鲜奶周期
  async getPeriodOptionalAfterOrder({ commit }, { params }) {
    const response = await getPeriodOptionalAfterOrder(params);
    if (response.code === 1) {
      commit("SET_GET_PERIOD_OPTIONAL_AFTERORDER", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 申请售后
  async addAfterSale({ commit }, { params }) {
    const response = await addAfterSale(params);
    if (response.code === 1) {
      commit("SET_ADD_AFTER_SALE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 微信支付接口
  async paymentPage({ commit }, { params }) {
    const response = await paymentPage(params);
    // console.log(response, "paymentPage 接口");
    if (response.code === 1) {
      commit("SET_PAYMENT_PAGE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 支付通知接口
  async paySuccessd({ commit }, { params }) {
    const response = await paySuccessd(params);
    if (response.code === 1) {
      commit("SET_PAYMENT_SUCC", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 支付
  async jsticket({ commit }, { params }) {
    const response = await jsticket(params);
    if (response.code === 1) {
      commit("SET_JSTICKET", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 扫码领取卡详情
  async queryCardVoucherUserByIdNoUserId({ commit }, { params }) {
    const response = await queryCardVoucherUserByIdNoUserId(params);
    if (response.code === 1) {
      commit("SET_QUERY_CARD_VOUCHER_UESER_BY_ID_NO_USERID", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 扫码领取卡详情立即领取
  async presentCardVoucherUser({ commit }, { params }) {
    const response = await presentCardVoucherUser(params);
    if (response.code === 1) {
      commit("", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 鲜奶配送计划查看物流
  async getTrackingDataByTrackingNo({ commit }, { params }) {
    const response = await getTrackingDataByTrackingNo(params);
    if (response.code === 1) {
      commit("SET_GET_TRACKING_DATA_BY_TRACKING_NO", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
